import { render, staticRenderFns } from "./modalDosageTime.vue?vue&type=template&id=2b090318&"
import script from "./modalDosageTime.vue?vue&type=script&lang=js&"
export * from "./modalDosageTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports